export default "__VITE_ASSET__CNoU5TkT__$_?nuxt_component=async&nuxt_component_name=IUsdgLogoUsimsaLogoWhiteIcon__"